import React from 'react'
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import prof from '../../Assets/avatar.png'
import { Col } from 'react-bootstrap';
import { MdMail, MdOutlineWorkOutline } from 'react-icons/md';
import Crud from '../Crud/Crud';
import { GiSmartphone } from 'react-icons/gi';
import { ImLocation2 } from 'react-icons/im';
import './CardProf.css'

export default function CardProf({ item }) {

    const elt_collection = 'users';

    const myphoto = item?.photo !== undefined? item?.photo : prof;


    return (
        <Col lg={4} md={6}>
            
            <Card className='my-2 cardProf position-relative py-3' >
                <div className='position-absolute top-0 end-0'>
                    <Crud
                        isArchived={item?.isArchived}
                        elt_collection={elt_collection}
                        id={item?.id} />
                </div>
                <div className="cnt-img d-flex flex-column box  justify-content-center pt-2 align-items-center">
                    <div className="image">
                        <img className='imgimg' src={myphoto} alt="" />
                    </div>
                    <div className=" bd-highlight">
                        <span className="text-capitalize name_job fw-bold">{item?.nom} {item?.prenom}</span>
                    </div>
                    <div>
                        <MdOutlineWorkOutline /> {item?.domaine}
                    </div>
                    <div>
                        <MdMail /> {item?.email}
                    </div>
                    <div>
                        <GiSmartphone /> {item?.tel}
                    </div>
                    <Form.Text smuted className='px-1 text-center'>
                        <ImLocation2 /> {item?.residence}
                    </Form.Text>
                </div>
            </Card >
        </Col>
    )
}
